import Vue from 'vue'
import UserMixin from '@/components/helpers/mixins/user-mixin'

export default Vue.extend({
  template: `
    <div class="filter-container">
      <input
        placeholder="Содержит..."
        style="height: 50px; width: 200px"
        class="filter-input"
        :ref="'input'"
        v-model="filterText"
        v-if="showFilter"
      >
      <em
        class='fas fa-times clear-icon'
        @click="onClear"
      >
      </em>
    </div>
  `,
  data() {
    return {
      filterText: '',
      valueGetter: null,
      showFilter: true,
      model: null
    }
  },
  mixins: [UserMixin],
  methods: {
    isFilterActive() {
      return this.filterText !== null && this.filterText !== undefined && this.filterText !== ''
    },
    doesFilterPass() {
      return !this.filterText || this.filterText.toLowerCase()
    },
    getModel() {
      return { value: this.filterText }
    },
    afterGuiAttached() {
      this.$refs.input.focus()
    },
    onClear() {
      this.filterText = ''
    },
    onSbm() {
      this.showFilter = false
    },
    setModel(model) {
      if (model) {
        this.filterText = model.value
      } else {
        this.filterText = ''
      }
    }
  },
  watch: {
    filterText(val, oldVal) {
      if (val !== oldVal) {
        this.params.filterChangedCallback()
      }
    }
  },
  created() {
    this.valueGetter = this.params.valueGetter
    this.field = this.params.colDef.field
  }
})
